// Test IDs para el flujo público de rastreo (Torre de Control).
export const RASTREO = {
  // Home / búsqueda
  searchInput: 'rastreo-search-input',
  searchButton: 'rastreo-search-button',
  brandHeader: 'rastreo-brand-header',
  helperStrip: 'rastreo-helper-strip',
  // Desambiguación
  disambiguationList: 'rastreo-disambiguation-list',
  disambiguationCard: 'rastreo-disambiguation-card',
  // No encontrado
  notFound: 'rastreo-not-found',
  notFoundBack: 'rastreo-not-found-back',
  // Error de servicio (distinto de "no encontrado")
  searchError: 'rastreo-search-error',
  searchErrorRetry: 'rastreo-search-error-retry',
  serviceError: 'rastreo-service-error',
  serviceErrorRetry: 'rastreo-service-error-retry',
  rateLimitError: 'rastreo-rate-limit-error',
  // Detalle
  detailHeader: 'rastreo-detail-header',
  detailVin: 'rastreo-detail-vin',
  detailStageBadge: 'rastreo-detail-stage-badge',
  timeline: 'rastreo-timeline',
  timelineStep: 'rastreo-timeline-step',
  vehicleCard: 'rastreo-vehicle-card',
  shippingCard: 'rastreo-shipping-card',
  gallery: 'rastreo-gallery',
  galleryPhoto: 'rastreo-gallery-photo',
  lightbox: 'rastreo-lightbox',
  lightboxClose: 'rastreo-lightbox-close',
  lightboxPrev: 'rastreo-lightbox-prev',
  lightboxNext: 'rastreo-lightbox-next',
  lightboxCounter: 'rastreo-lightbox-counter',
  backHome: 'rastreo-back-home',
  // Videos del destinatario (enlace de la unidad)
  videosPanel: 'rastreo-videos-panel',
  videoAddButton: 'rastreo-video-add-button',
  videoCameraButton: 'rastreo-video-camera-button',
  videoFileInput: 'rastreo-video-file-input',
  videoCameraInput: 'rastreo-video-camera-input',
  videoProgress: 'rastreo-video-progress',
  videoCancelButton: 'rastreo-video-cancel-button',
  videoError: 'rastreo-video-error',
  videoRetryButton: 'rastreo-video-retry-button',
  videoSuccess: 'rastreo-video-success',
  videoItem: 'rastreo-video-item',
  videoPlayer: 'rastreo-video-player',
  videoDownload: 'rastreo-video-download',
  videoLinkInvalid: 'rastreo-video-link-invalid',
};
